import { mergeStyleSets } from '@fluentui/react';

export interface IComponentClassNames {
    panel: string,
    panelHeader: string,
    panelHeaderTitle: string,
    panelHeaderActions: string,
    panelBody: string,
    nodeRow: string,
    nodeRowSelected: string,
    nodeInfo: string,
    nodeLabelBlock: string,
    nodeText: string,
    nodeDescription: string,
    chevron: string,
    chevronPlaceholder: string,
    emptyState: string,
}

export const getClassNames = (): IComponentClassNames => {
    return mergeStyleSets({
        panel: {
            width: 375,
            height: 'calc(100vh - 28px)',
            border: '1px solid #eee',
            boxSizing: 'border-box',
            backgroundColor: 'rgb(243, 242, 241)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            flexShrink: 0,
            boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'
        },
        panelHeader: {
            padding: '15px 16px',
            borderBottom: '1px solid #edebe9',
            fontSize: 14,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        panelHeaderTitle: {
            display: 'flex',
            gap: 10,
            alignItems: 'center',
            minWidth: 0,
        },
        panelHeaderActions: {
            display: 'flex',
            gap: 6,
            alignItems: 'center',
        },
        panelBody: {
            flexGrow: 1,
        },
        nodeRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            minHeight: 40,
            paddingTop: 1,
            paddingBottom: 1,
            paddingRight: 12,
            selectors: {
                ':hover': {
                    backgroundColor: '#f3f2f1'
                }
            }
        },
        nodeRowSelected: {
            backgroundColor: '#dff6dd',
            selectors: {
                ':hover': {
                    backgroundColor: '#d1f0ce'
                }
            }
        },
        nodeInfo: {
            display: 'flex',
            alignItems: 'flex-start',
            minWidth: 0,
            flexGrow: 1,
        },
        nodeLabelBlock: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
        },
        nodeText: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 13,
            fontWeight: 500,
        },
        nodeDescription: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: 11,
            fontStyle: 'italic',
            color: '#605e5c',
        },
        chevron: {
            cursor: 'pointer',
            width: 20,
            textAlign: 'center',
            fontSize: 12,
            color: '#605e5c',
            flexShrink: 0,
            marginTop: 2,
        },
        chevronPlaceholder: {
            width: 20,
            flexShrink: 0,
        },
        emptyState: {
            padding: 16,
            color: '#605e5c',
            fontSize: 13,
        }
    });
};